const home = {
	title:'欢迎来到新世界',
	notice:{
		title:'公告信息',
		more:'查看更多'
	},
	banner:[
		{
			title:'EPD',
			content:'EPD指环境产品声明（Environmental Product Declaration），是提供基于预设参数的量化环境数据的环境声明，必要时包括附加环境信息。',
			img:require('@/assets/img/index/EPD_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},
		{
			title:'GPI',
			content:'GPI是基于ISO14025 III型环境声明的原则和程序建立的管理规则，是中国有色金属行业EPD平台的运作基础。',
			img:require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png'),
			tips:'GPI',
			left:'110px',
			top:'55px',
			color:'#35b082'
		},	
		{
			title:'PCR',
			content:'PCR指产品种类规则（Product-Category Rules），是对一个或多个产品种类进行Ⅲ型环境声明（即EPD）所必须满足的一套具体的规则、要求和指南。',
			img: require('@/assets/img/index/PCR_2x.png'),
			url: require('@/assets/img/index/banner01.png') 
		},	
		{
			title:'LCA',
			content:'LCA指生命周期评价（Life Cycle Assessment），是对一个产品系统的生命周期中输入、输出及其潜在环境影响的汇编和评价。',
			img:require('@/assets/img/index/LCA_2x.png'),
			url: require('@/assets/img/index/banner01.png'),
			tips:'LCA',
			left:'120px',
			top:'125px',
			color:'#fe8a46'
		},
		{
			title:'CFP',
			content:'CFP指产品碳足迹（Carbon Footprint Of A Product），是产品系统中的温室气体排放量和温室气体去除量之和，以二氧化碳当量为单位表示，基于使用气候变化单一影响类别的生命周期评价。',
			img:require('@/assets/img/index/CFP_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},	
	],
	tabCard:[
		{
			title:'搜索PCR',
			url:require('@/assets/img/index/seach-pcr_2x.png'),
			path:'/seach',
			flag: 'PCR'
		},
		{
			title:'搜索EPD/CFP',
			url:require('@/assets/img/index/seach-epd_2x.png'),
			path:'/seach',
			flag: 'EPD'
		},
		{
			title:'申请EPD/CFP',
			url:require('@/assets/img/index/seach-crp_2x.png'),
			path:'/apply',
			flag: ''
		}		
	],
}

 export default home